import { graphql as tadaGraphql } from '@savvy/deprecated-shared/gql-compat';

export const XLoginQuery = tadaGraphql(/* GraphQL */ `
  query XLogin {
    client {
      ...LoginForm
      user {
        email
        firstName
        phoneNumber
      }
      household {
        coClient {
          user {
            firstName
          }
        }
      }
    }
  }
`);
